import { render } from "./StickyHeader.vue?vue&type=template&id=02961f6c&scoped=true"
import script from "./StickyHeader.vue?vue&type=script&lang=js"
export * from "./StickyHeader.vue?vue&type=script&lang=js"

import "./StickyHeader.vue?vue&type=style&index=0&id=02961f6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02961f6c"]])

export default __exports__